import { useEffect, useState } from "react";
import { forecastDashboardRanges, type DashboardRange } from "@/lib/dashboard-analytics";
import { normalizeCashflowTrend, type CashflowSeriesPoint } from "@/lib/admin-dashboard-charts";
import apiService from "@/services/apiService";
import { DashboardLineChart } from "./DashboardLineChart";
import { DashboardBreakdownTable } from "./DashboardBreakdownTable";

export function AstrafinCashflowChart() {
  const [range, setRange] = useState<DashboardRange>("current_fy");
  const [data, setData] = useState<CashflowSeriesPoint[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      setLoading(true);
      try {
        const response = await apiService.get<unknown>(
          "/rental-schedule/admin-dashboard-cashflow-trend",
          { params: { range } }
        );
        if (cancelled) return;
        setData(normalizeCashflowTrend(response));
      } catch (error) {
        console.error("Failed to load Astrafin cashflow trend:", error);
        if (!cancelled) setData([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [range]);

  const series = [{ key: "amount", label: "Cashflow to Astrafin", color: "hsl(var(--primary))" }];
  const columns = series.map((item) => ({ key: item.key, label: item.label }));
  return (
    <DashboardLineChart
      title="Cashflow to Astrafin"
      eyebrow="Portfolio cashflow forecast"
      data={data}
      loading={loading}
      series={series}
      range={range}
      onRangeChange={setRange}
      rangeOptions={forecastDashboardRanges}
      detailDescription="Forecast cashflow from the Portfolio Cashflow Waterfall, including inception, rentals, GST, TDS and security deposit movements; not actual bank receipts. Indian FY: April–March."
      details={<DashboardBreakdownTable data={data} columns={columns} />}
    />
  );
}
